// @flow
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import ReactDOM from 'react-dom'
import Divider from '@material-ui/core/Divider'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import IconButton from '@material-ui/core/IconButton'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import TableProperties from './table_properties'
import layerPanelStyles from 'catena/er2_styles/layers'

type PropTypes = {
    layer_type: string,
    mapsource: string,
    muiTheme: any,
    name: string,
    onChangeProps: Function,
    onDelete: Function,
    onDownload: Function,
    onGetAttributes: Function,
    row_count: number,
    theme?: layerPanelStyles,
}

class Table extends React.Component<PropTypes> {
    constructor(props) {
        super(props)
        this.state = {
            displayProps: false,
            editName: null,
            expanded: false,
            ...props,
        }
    }

    onRename = () => {
        this.setState({
            editName: this.state.name,
        })
    }

    onBlurName = (e) => {
        this.props.onChangeProps({ name: this.state.editName })
        this.setState({
            editName: null,
        })
    }

    onChangeName = (e) => {
        this.setState({
            editName: e.target.value,
        })
    }

    setFocus = e => e.target.select()

    render() {
        const showProps = (e) => {
            this.setState({ displayProps: !this.state.displayProps })
        }
        const onDelete = (e) => {
            this.props.onDelete(e)
            e.stopPropagation()
        }
        const onDownload = (e) => {
            this.props.onDownload(e)
            e.stopPropagation()
        }
        const expansionPanelClick = (event, expanded) => {
            this.setState({ expanded })
        }
        const stopPropagation = e => e.stopPropagation()

        let tableprops = null
        if (this.state.displayProps) {
            const updateTableProperties = (layerProps) => {
                this.props.onChangeProps(layerProps)
            }
            const { top, left } = this.ref.getBoundingClientRect()
            const root = document.getElementById('root')
            tableprops = ReactDOM.createPortal((
                <TableProperties
                    tableProps={this.props}
                    onChangeProps={updateTableProperties}
                    onClose={() => this.setState({ displayProps: false })}
                    pos={{ top, right: root.getBoundingClientRect().right - left }}
                />
            ), root)
        }

        const getLayerDetails = () => (
            <div>
                <div><span className={this.props.theme.layerOverviewLabel}>Feature Count</span><span
                    className={this.props.theme.layerOverviewItem}
                >{this.props.row_count}</span></div>
            </div>
        )

        return (
            <div ref={el => (this.ref = el)}>
                <div
                    className={this.props.theme.layerPropsDiv}
                >
                    {tableprops}
                </div>
                <ExpansionPanel
                    classes={{
                        expanded: this.props.theme.panelExpanded,
                    }}
                    className={this.props.theme.panel}
                    onChange={expansionPanelClick}
                    style={{ backgroundColor: this.state.displayProps ? 'rgba(227, 234, 237)' : 'white' }}
                >
                    <ExpansionPanelSummary
                        classes={{
                            content: `${this.props.theme.panelSummary} ${this.state.expanded ? this.props.theme.panelClicked : ''}`,
                            expandIcon: this.props.theme.expandButton,
                        }}
                        className={this.props.theme.panelSummary}
                        expandIcon={<ExpandMoreIcon />}
                    >
                        {this.state.editName ? (
                            <TextField
                                autoFocus
                                value={this.state.editName}
                                onChange={this.onChangeName}
                                onBlur={this.onBlurName}
                                onFocus={this.setFocus}
                                onKeyDown={(ev) => {
                                    if (ev.key === 'Enter') {
                                        // Do code here
                                        this.onBlurName(ev)
                                        ev.preventDefault()
                                    } else if (ev.key === 'Escape') {
                                        this.setState({ editName: null })
                                        ev.preventDefault()
                                    }
                                }}
                            />
                        ) : (
                            <Typography
                                classes={{
                                    body1: this.props.theme.labelTable,
                                    root: this.props.theme.label,
                                }}
                                className={this.props.theme.labelTable}
                            >
                                {this.props.name}
                            </Typography>
                        )}
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails
                        className={this.props.theme.panelDetails}
                    >
                        <div className={this.props.theme.table}>
                            <div className={this.props.theme.row}>
                                <IconButton
                                    onClick={showProps}
                                    className={this.props.theme.littleButton}
                                >
                                    <i className={'fa fa-window-restore'} role="button" />
                                </IconButton>
                                <IconButton
                                    onClick={this.props.onGetAttributes}
                                    className={this.props.theme.littleButton}
                                >
                                    <i className={'fa fa-table'} role="button" />
                                </IconButton>
                                <IconButton
                                    onClick={onDownload}
                                    className={this.props.theme.littleButton}
                                >
                                    <i className={'fa fa-download'} role="button" />
                                </IconButton>
                                <IconButton
                                    onClick={onDelete}
                                    className={this.props.theme.littleButton}
                                >
                                    <i className={'fa fa-trash'} role="button" />
                                </IconButton>
                                <IconButton
                                    onClick={this.onRename}
                                    className={this.props.theme.littleButton}
                                >
                                    <i className={'fa fa-pencil'} role="button" />
                                </IconButton>
                            </div>
                            <Divider />
                        </div>
                        <div className={this.props.theme.table}>
                            <div
                                className={this.props.theme.columnBorder}
                                style={{ borderLeft: `1px solid ${this.state.displayProps ? '#aaa' : '#ccc'}` }}
                            >
                                {getLayerDetails()}
                            </div>
                        </div>
                    </ExpansionPanelDetails>
                </ExpansionPanel>
            </div>
        )
    }
}

Table.defaultProps = {
    theme: layerPanelStyles,
}

export default Table
